/*
 * Navigation tools: they move the playhead or the selection, which is view
 * state, so nothing here is recorded in history.
 */

import { resolveEvents, resolveGroup } from "./guards.js";

function seek(input, ctx) {
    if (!(input.time >= 0)) return { error: "time must be 0 or more seconds." };
    ctx.seek(input.time);
    return { content: `Player moved to ${ctx.formatTc(input.time)}.`, activity: { kind: "seek", time: input.time } };
}

function selectGroup(input, ctx) {
    const resolved = resolveGroup(ctx, input.group);
    if (resolved.error) return { error: resolved.error };
    ctx.selectGroup(resolved.index);
    return {
        content: `Group ${input.group} is now selected.`,
        activity: { kind: "select_group", groupIndex: resolved.index, groupName: resolved.group.name },
    };
}

function selectEvents(input, ctx) {
    const resolved = resolveGroup(ctx, input.group);
    if (resolved.error) return { error: resolved.error };
    const events = resolveEvents(resolved.group, input.events);
    if (events.error) return { error: events.error };
    ctx.selectEvents(resolved.index, events.indexes);
    return {
        content: `Selected ${events.indexes.length} event(s) in group ${input.group}.`,
        activity: { kind: "select_events", groupIndex: resolved.index, groupName: resolved.group.name, count: events.indexes.length },
    };
}

export const NAV_TOOLS = {
    seek,
    select_group: selectGroup,
    select_events: selectEvents,
};
